import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronDown, Dumbbell, Check, Loader2 } from 'lucide-react';
import { useClientAuth } from '../../../context/ClientAuthContext';

/** Guide explicatif des méthodologies de musculation (superset, drop set, rest-pause, AMRAP,
 * EMOM...) — même format que le Guide Cardio, pour une expérience cohérente entre les 2 modules. */
export const MethodologyGuide = ({ en, onBack }) => {
  const L = (fr, eng) => (en ? eng : fr);
  const { authFetch } = useClientAuth();
  const [methodologies, setMethodologies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openValue, setOpenValue] = useState(null);

  useEffect(() => {
    authFetch('/api/tracking/programs-pro/methodology-guide').then((r) => r.json()).then((d) => setMethodologies(d.methodologies || [])).finally(() => setLoading(false));
  }, [authFetch]);

  return (
    <div className="space-y-4" data-testid="methodology-guide">
      <button onClick={onBack} className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white text-sm" data-testid="methodology-guide-back-btn">
        <ChevronLeft className="w-4 h-4" /> {L('Retour', 'Back')}
      </button>
      <h2 className="text-xl font-black text-white flex items-center gap-2">
        <Dumbbell className="w-5 h-5 text-primary" /> {L('Guide des méthodologies', 'Methodologies Guide')}
      </h2>
      {loading ? (
        <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
      ) : (
        <div className="space-y-2.5">
          {methodologies.map((m) => {
            const open = openValue === m.value;
            return (
              <div key={m.value} className="rounded-2xl bg-white/[0.035] backdrop-blur-xl border border-white/10 overflow-hidden" data-testid={`methodology-guide-item-${m.value}`}>
                <button onClick={() => setOpenValue(open ? null : m.value)} className="w-full flex items-center gap-3 p-4 text-left" data-testid={`methodology-guide-toggle-${m.value}`}>
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-primary flex items-center justify-center shrink-0">
                    <Dumbbell className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-white font-bold text-sm">{en ? m.label_en : m.label}</p>
                  </div>
                  <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform shrink-0 ${open ? 'rotate-180' : ''}`} />
                </button>
                <AnimatePresence>
                  {open && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <div className="px-4 pb-4 pt-1 space-y-3">
                        <p className="text-sm text-zinc-300 leading-relaxed">{en ? m.guide_en : m.guide}</p>
                        <ul className="space-y-1.5">
                          {(en ? m.benefits_en : m.benefits || []).map((b, i) => (
                            <li key={i} className="flex items-start gap-2 text-xs text-zinc-400">
                              <Check className="w-3.5 h-3.5 text-emerald-400 mt-0.5 shrink-0" /> {b}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MethodologyGuide;
